import React from 'react';
import { Row, Col, Card, CardBody, InputGroupAddon } from 'reactstrap';
import { Form } from '@availity/form';
import { Input } from '../../lib/form-field';
import '@availity/yup';
import formValidation from './formValidation';

import * as shortLinksActions from '../../store/shortLinks/actions';
import { useDispatch } from 'react-redux';

import { SubmitButton } from '../Common/Modal/modalActionButtons';

import getShortLinkBaseUrl from '../../config/shortLinks';

const SHORT_LINK_BASE_URL = `${getShortLinkBaseUrl()}/`;

const FormShortLink = ({ shortLink, closeModal, loading }) => {
  const editingShortLink = shortLink || {};

  const dispatch = useDispatch();

  const handleSubmit = (values) => {
    dispatch(shortLinksActions.createShortLink(values));
    closeModal();
  };

  return (
    <Card>
      <CardBody>
        <Form
          initialValues={editingShortLink}
          validationSchema={formValidation}
          onSubmit={handleSubmit}
        >
          {({ isValid }) => (
            <>
              <Row>
                <Col md="4">
                  <Input
                    type="text"
                    name="slug"
                    id="slug"
                    addonType="prepend"
                    subText="If not provided, it will be generated automatically."
                  >
                    <InputGroupAddon addonType="prepend">
                      {SHORT_LINK_BASE_URL}
                    </InputGroupAddon>
                  </Input>
                </Col>
                <Col md="8">
                  <Input
                    name="target"
                    id="target"
                    subText="The target URL to redirect to."
                  />
                </Col>
              </Row>
              <Row>
                <Col md="8">
                  <Input type="textarea" name="description" id="description" />
                </Col>
              </Row>
              <div className="modal-footer">
                <SubmitButton disabled={!isValid || loading} create />
              </div>
            </>
          )}
        </Form>
      </CardBody>
    </Card>
  );
};

export default FormShortLink;
